import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import RawMaterialSearch from "./RawMaterial-Search";
import RawMaterialDatatable from "./RawMaterialList-Datatable";
import RawMaterialService from "../../../services/RawMaterials/RawMaterialService";

const RawMaterialsMainPage: React.FC = () => {
  const { t } = useTranslation();
  const [rawMaterials, setRawMaterials] = useState<any[]>([]);
  const [filteredRawMaterials, setFilteredRawMaterials] = useState<any[]>([]);
  const [selectedKeyword, setSelectedKeyword] = useState("");

  useEffect(() => {
    fetchRawMaterials();
  }, []);

  useEffect(() => {
    handleSearch(selectedKeyword);
  }, [selectedKeyword, rawMaterials]);

  const fetchRawMaterials = async () => {
    try {
      const response = await RawMaterialService.getAllRawMaterials();
      setRawMaterials(response.data || []);
      setFilteredRawMaterials(response.data || []);
    } catch (error) {
      console.error("Error fetching raw materials:", error);
      setRawMaterials([]);
      setFilteredRawMaterials([]);
    }
  };

  const handleSearch = (searchText: string) => {
    if (!searchText) {
      setFilteredRawMaterials(rawMaterials);
      return;
    }

    const filtered = rawMaterials.filter((item) =>
      Object.values(item)
        .join(" ")
        .toLowerCase()
        .includes(searchText.toLowerCase())
    );

    setFilteredRawMaterials(filtered);
  };

  return (
    <div className="layout-content mt-3 mb-3 grid grid-table-mobile">
      <div className="col-12 mb-2">
        <h4 className="ml-1 mb-0">{t("Raw Materials")}</h4>
      </div>

      <RawMaterialSearch onSearch={setSelectedKeyword} />
      <RawMaterialDatatable rawMaterials={filteredRawMaterials} setRawMaterials={setRawMaterials} />
    </div>
  );
};

export default RawMaterialsMainPage;
